/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict'

window._bd_share_config = {
	"common" : {
		"bdSnsKey" : {},
		"bdText" : "",
		"bdMini" : "2",
		"bdPic" : "",
		"bdStyle" : "0",
		"bdSize" : "16"
	},
	"share" : {},
	"image" : {
		"viewList" : ["qzone", "tsina", "tqq", "renren", "weixin"],
		"viewText" : "分享到：",
		"viewSize" : "16"
	},
	"selectShare" : {
		"bdContainerClass" : null,
		"bdSelectMiniList" : ["qzone", "tsina", "tqq", "renren", "weixin"]
	}
};
var head = document.getElementsByTagName('head')[0];
var script = document.createElement('script');
script.type = 'text/javascript';
script.charset = 'utf-8';
script.async = true;
script.src = 'http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5);
head.appendChild(script);



// WEBPACK FOOTER //
// ./src/main/javascript/vendor/com.jufeng.baidu.share.js